import React, { FC, useState } from 'react';
import { useTranslate } from '@/translations';
import { PageContainer, Title, faBarsProgress } from '@/ui/components';
import { StorageKeys } from '@/utils/constants';

import { Card, Segmented } from 'antd';
import { JobChainsDataGrid } from './components/JobChainsDataGrid';
import { JobsDataGrid } from './components/JobsDataGrid';

type CompoundJobsView = 'chains' | 'jobs';

const readView = (): CompoundJobsView =>
  localStorage.getItem(StorageKeys.CompoundJobsView) === 'jobs'
    ? 'jobs'
    : 'chains';

export const ManageJobs: FC = () => {
  const { t } = useTranslate();
  const [view, setView] = useState<CompoundJobsView>(readView);

  return (
    <PageContainer>
      <Title title={t('compoundJobs')} icon={faBarsProgress} />
      <Card>
        <Segmented
          style={{ marginBottom: 16 }}
          value={view}
          onChange={(value) => {
            const next = value as CompoundJobsView;
            setView(next);
            localStorage.setItem(StorageKeys.CompoundJobsView, next);
          }}
          options={[
            { label: t('jobChains'), value: 'chains' },
            { label: t('jobs'), value: 'jobs' },
          ]}
        />
        {view === 'chains' ? <JobChainsDataGrid /> : <JobsDataGrid />}
      </Card>
    </PageContainer>
  );
};

export { JobChainDetailPage } from './components/JobChainDetailPage';
